import React from "react";
import {
  SelectField,
  SelectList,
  SimpleList,
  SimpleListItem,
} from "../../../../components";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Box,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { ChevronBigRight, Filter } from "@tiny/icons";
import ListHeader from "../../../ListHeader/ListHeader";
import TagsDialog from "../../../TagsDialog";
import { filterOptions } from "../DragAndDropTab.helpers";
import { useDragAndDropHeader } from "./DragAndDropHeader.hooks";

function DragAndDropHeader() {
  const {
    activeFilter,
    allSelected,
    allSelectedDisabled,
    changeActiveFilter,
    closeFilters,
    closeMore,
    closeSectionsFilter,
    deleteSelected,
    deselectAll,
    deselectTag,
    filtersOpen,
    moreOpen,
    openFilters,
    openMore,
    openSectionsFilter,
    search,
    sectionsFilterOpen,
    selectedTags,
    selectedIds,
    tags,
    toggleAll,
    tempActiveFilter,
    setTempActiveFilter,
    applySectionFilter,
    selectable,
    isFavoritesSelected,
    setIsFavoritesSelected,
    updateDialogSelections,
  } = useDragAndDropHeader();

  return React.useMemo(
    () => (
      <>
        <ListHeader
          allSelected={allSelected}
          allSelectedDisabled={allSelectedDisabled}
          bulkDeleteEnabled
          onDeleteClick={deleteSelected}
          onDeselectAll={deselectAll}
          onMoreMobile={openMore}
          onSearchChange={search}
          onTagDelete={deselectTag}
          onToggleAll={toggleAll}
          totalSelected={selectedIds.length}
          tags={selectedTags}
          selectable={selectable}
          actions={
            <Box width={140} my={2}>
              <FormControl size="small" fullWidth>
                <Select
                  fullWidth
                  //@ts-ignore
                  onChange={(e) => changeActiveFilter(e.target.value)}
                  value={activeFilter}
                >
                  {filterOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          }
          extra={
            <Box>
              <Button
                variant="outlined"
                color="primary"
                onClick={openFilters}
                endIcon={<Filter />}
              >
                Filter
              </Button>
            </Box>
          }
        />
        <TagsDialog
          open={filtersOpen}
          onClose={closeFilters}
          onSave={updateDialogSelections}
          tags={tags}
          selected={selectedTags}
          isFavoritesSelected={isFavoritesSelected}
          setIsFavoritesSelected={setIsFavoritesSelected}
        />
        <Dialog open={moreOpen} onClose={closeMore} disableScrollLock>
          <DialogContent sx={{ pt: 2, pb: 2 }}>
            <SimpleList>
              <SimpleListItem
                icon={<ChevronBigRight />}
                size="large"
                onClick={openFilters}
              >
                Filters ({selectedTags.length})
              </SimpleListItem>
              <SimpleListItem
                icon={<ChevronBigRight />}
                size="large"
                onClick={openSectionsFilter}
              >
                Section ({activeFilter})
              </SimpleListItem>
            </SimpleList>
          </DialogContent>
        </Dialog>
        <Dialog
          open={sectionsFilterOpen}
          onClose={closeSectionsFilter}
          disableScrollLock
        >
          <DialogTitle>Section</DialogTitle>
          <DialogContent
            sx={{
              pt: 2,
            }}
          >
            <Box mb={4}>
              <Divider />
            </Box>
            <SelectList
              options={filterOptions}
              onChangeValue={setTempActiveFilter}
              value={tempActiveFilter}
            />
            <Box mt={4}>
              <Divider />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" fullWidth onClick={applySectionFilter}>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </>
    ),
    [
      allSelected,
      allSelectedDisabled,
      deleteSelected,
      deselectAll,
      openMore,
      search,
      deselectTag,
      toggleAll,
      selectedIds.length,
      selectedTags,
      selectable,
      activeFilter,
      changeActiveFilter,
      openFilters,
      filtersOpen,
      closeFilters,
      updateDialogSelections,
      tags,
      isFavoritesSelected,
      setIsFavoritesSelected,
      moreOpen,
      closeMore,
      openSectionsFilter,
      sectionsFilterOpen,
      closeSectionsFilter,
      setTempActiveFilter,
      tempActiveFilter,
      applySectionFilter,
    ]
  );
}

export default DragAndDropHeader;
